import { connect } from 'react-redux';
import { compose } from 'redux';
import AssignmentPage from './AssignmentPage';
import withAnalyticsHoc from '$utils/withAnalyticsHoc';
import {
  actions as assignmentsActions,
  selectors as assignmentsSelectors,
} from '$data/assignments';
import {
  actions as providersActions,
  selectors as providersSelectors,
} from '$data/providers';
import { selectors as coreSelectors } from '$data/core';
import launchTurnitinAssignment from '$utils/launchTurnitinAssignment';
import { VIEW_ASSIGNMENT_PAGE } from '$variables/analyticsEvents';

const createLaunchTurnitinAssignmentFunction = (state) => (assignmentId) => {
  const spaceId = coreSelectors.getCurrentSpace(state).id;
  const user = coreSelectors.getUser(state);
  const assignment = assignmentsSelectors.getAssignmentById(
    state,
    assignmentId
  );

  launchTurnitinAssignment({
    user,
    spaceId,
    assignment,
  });
};

const mapStateToProps = (
  state,
  {
    match: {
      params: { assignmentId },
    },
  }
) => ({
  spaceId: coreSelectors.getCurrentSpaceId(state),
  assignment: assignmentsSelectors.getAssignmentById(state, assignmentId),
  ltiProviders: providersSelectors.getProvidersById(state),
  grades: assignmentsSelectors.getGradesByAssignment(state, assignmentId),
  assignmentLoading:
    assignmentsSelectors.getAssignmentLoading(state) ||
    providersSelectors.getProvidersIsLoading(state),
  gradesLoading: assignmentsSelectors.getGradesLoading(state),
  error:
    assignmentsSelectors.getAssignmentError(state) ||
    providersSelectors.getProvidersError(state),
  launchTurnitinAssignment: createLaunchTurnitinAssignmentFunction(state),
  isUpdatingAssignment: assignmentsSelectors.getIsUpdatingAssignment(state),
  currentGrades: assignmentsSelectors.getCurrentGrades(state, assignmentId),
  totalGrades: assignmentsSelectors.getTotalGrades(state, assignmentId),
  isReleasingGrades: assignmentsSelectors.getIsReleasingGrades(state),
  isSavingManualAssignmentGrade:
    assignmentsSelectors.getIsSavingGradeManualAssignment(state, assignmentId),
  saveManualGradeErrors: assignmentsSelectors.getManualGradeSavingErrors(
    state,
    assignmentId
  ),
  lastSavedAtGradeManualAssignment:
    assignmentsSelectors.getLastSavedAtGradeManualAssignment(
      state,
      assignmentId
    ),
  isUploadingGrades: assignmentsSelectors.getIsUploadingManualAssignmentGrades(
    state,
    assignmentId
  ),
  viewAs: coreSelectors.getViewAs(state),
});

const withAnalytics = withAnalyticsHoc({
  eventName: VIEW_ASSIGNMENT_PAGE,
});

const mapDispatchToProps = {
  fetchAssignment: assignmentsActions.fetchAssignment,
  fetchGrades: assignmentsActions.fetchGradesForAssignment,
  updateAssignment: assignmentsActions.updateAssignment,
  deleteAssignment: assignmentsActions.deleteAssignment,
  gradeManualAssignment: assignmentsActions.gradeManualAssignment,
  releaseGrades: assignmentsActions.releaseGrades,
  importManualAssignmentGrades: assignmentsActions.importManualAssignmentGrades,
  fetchLtiProviders: providersActions.fetchLtiProviders,
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withAnalytics
)(AssignmentPage);
